import React, { useEffect } from 'react'
import { useQuery } from 'react-apollo-hooks'
import styled from 'react-emotion'
import { LinkWithIcon, Loader } from '../application'
import { TextErrors } from '../notification'
import { urls } from '../resources'
import { Container } from '../styles'
import Airports from './components/Airports'
import Partners from './components/Partners'
import { setPreferencesInCookie } from './cookieHandler'
import * as Queries from './queries'
import getText, { getTextErrors } from './strings'

const ModualContainer = styled('div')`
  margin: 0 10px 20px 10px;
`

export default () => {
  const { loading, data, refetch } = useQuery(Queries.getSettings(), { notifyOnNetworkStatusChange: true })

  useEffect(() => {
    if (!loading && data.airports) {
      setPreferencesInCookie(data.airports)
    }
  }, [data])

  if (loading) {
    return (
      <Container>
        <Loader />
      </Container>
    )
  }

  return (
    <Container>
      <ModualContainer>
        <TextErrors textErrors={getTextErrors()} />
        <h2>{getText('overview', 'title')}</h2>
        <Partners partners={data.partners} onSave={() => refetch()} />
        <Airports airports={data.airports} onSave={() => refetch()} />
        <br />
        <LinkWithIcon icon="chevron-right" to={urls.privacy} text={getText('overview', 'privacySettings')} iconRight />
      </ModualContainer>
    </Container>
  )
}
